/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type ParticipantCountSecondaryQueryVariables = {
    readonly cmId?: string | null;
    readonly showActive?: boolean | null;
};
export type ParticipantCountSecondaryQueryResponse = {
    readonly participants: ({
        readonly participant: ReadonlyArray<({
            readonly id: string;
        }) | null> | null;
    }) | null;
};
export type ParticipantCountSecondaryQuery = {
    readonly response: ParticipantCountSecondaryQueryResponse;
    readonly variables: ParticipantCountSecondaryQueryVariables;
};



/*
query ParticipantCountSecondaryQuery(
  $cmId: String
  $showActive: Boolean
) {
  participants(secondary_case_manager_id: $cmId, active_clients_only: $showActive) {
    participant {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "cmId",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "showActive",
            "type": "Boolean",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "participants",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "active_clients_only",
                    "variableName": "showActive"
                },
                {
                    "kind": "Variable",
                    "name": "secondary_case_manager_id",
                    "variableName": "cmId"
                }
            ],
            "concreteType": "Pagination",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "participant",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Participant",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ParticipantCountSecondaryQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "ParticipantCountSecondaryQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "ParticipantCountSecondaryQuery",
            "id": null,
            "text": "query ParticipantCountSecondaryQuery(\n  $cmId: String\n  $showActive: Boolean\n) {\n  participants(secondary_case_manager_id: $cmId, active_clients_only: $showActive) {\n    participant {\n      id\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'b728f6f2605eb42edcb0efedc7b05e72';
export default node;
